import React from 'react';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
import { CASE_REVIEW_STATUS_SUMITTED } from './CaseConstants';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/submitted' },
  { label: 'Submitted', to: '/user/case/submitted' },
];
const SubmittedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.submitted_case_list_title}
          caseReviewStatus={CASE_REVIEW_STATUS_SUMITTED}
          breadCrumbItems={BREAD_CRUMBS}
        />
      </div>
    </div>
  );
};

export default SubmittedCases;
